import { AppBar, Box, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ButtonIniciarContato from 'components/ButtonIniciarContato';
import FilaEspera from 'components/FilaEspera';
import Logo from 'components/Logo';
import Profile from 'components/Profile';
import RedirectToAdmin from 'components/RedirectToAdmin';

const useStyles = makeStyles(({ palette, spacing }) => ({
  appBar: {
    color: palette.text.primary,
    backgroundColor: palette.background.paper,
    height: 56,
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginLeft: spacing(2),
    },
  },
}));

export default function Header() {
  const classes = useStyles();

  return (
    <AppBar elevation={0} position="relative" className={classes.appBar}>
      <Toolbar style={{ minHeight: 56, alignItems: 'center' }}>
        <Logo />

        <Box ml={4} flexGrow={1}>
          <FilaEspera />
        </Box>

        <Box aria-label="User section" className={classes.userSection}>
          <RedirectToAdmin />
          <ButtonIniciarContato />
          <Profile />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
